// extracted by mini-css-extract-plugin
export default {"container":"comingsoon_container__Hgl7g","action":"comingsoon_action__cguBd"};